"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "decode", {
  enumerable: true,
  get: function () {
    return _decode.default;
  }
});
Object.defineProperty(exports, "encode", {
  enumerable: true,
  get: function () {
    return _encode.default;
  }
});
var _encode = _interopRequireDefault(require("./encode"));
var _decode = _interopRequireDefault(require("./decode"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }